<template>
  <v-btn class="tour-subprojects mt-4" size="small" rounded v-bind="$attrs" @click="openNewSubproject()">
    <span class="d-inline-flex align-center">
      <v-icon size="large" class="mr-1">far fa-folder-plus</v-icon> {{ $t('PLANNING.NEW_SUBPROJECT') }}
      <premium-section icon feature="subprojects" class="ml-1"></premium-section>
    </span>
  </v-btn>

  <!-- MODALS -->
  <premium-section v-if="newSubprojectIsOpened" feature="subprojects" @close="newSubprojectIsOpened = false">
    <v-dialog :model-value="true" :max-width="600" height="100%" @update:model-value="newSubprojectIsOpened = false">
      <v-card class="px-6 pb-6">
        <v-btn-icon color="darkgrey" size="small" style="position: absolute; top: 0; right: 0" @click="newSubprojectIsOpened = false">
          <v-icon>far fa-times</v-icon>
        </v-btn-icon>
        <new-subproject :planning="planning" @close="newSubprojectIsOpened = false"></new-subproject>
      </v-card>
    </v-dialog>
  </premium-section>
</template>

<script>
  import NewSubproject from '@/components/Subprojects/NewSubproject';

  export default {
    components: {
      NewSubproject,
    },
    props: {
      planning: { type: Object, required: true },
    },
    data() {
      return {
        newSubprojectIsOpened: false,
      };
    },
    methods: {
      openNewSubproject() {
        this.newSubprojectIsOpened = true;
      },
    },
  };
</script>
